export class AssetLoaderError extends Error {
    public name = 'AssetLoaderError';
}
